import CustomButton from './custom-button';

export default CustomButton;
